'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import { reportError } from 'FileManagerCore/utils/logging';
import { jsx as _jsx } from "react/jsx-runtime";
const makeAsyncLoader = loader => {
  return Loadable({
    loader,
    LoadingComponent: ({
      pastDelay
    }) => {
      return pastDelay ? /*#__PURE__*/_jsx(UILoadingOverlay, {
        contextual: true,
        layout: "centered"
      }) : null;
    },
    ErrorComponent: ({
      error
    }) => {
      reportError('Async component error', error);
      return null;
    }
  });
};
export default makeAsyncLoader;